module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "create-form"
    }
  }, [_c('h1', [_vm._v("Create Form")]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'AllForm',
        params: {
          id: this.$route.params.client_id
        }
      }
    }
  }, [_vm._v("Return to forms")])], 1), _vm._v(" "), _c('notification', {
    attrs: {
      "notifications": _vm.notifications
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "name": "form_name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name_en),
      expression: "form.name_en"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "form_name",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.name_en)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name_en", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "name": "form_description_en"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description_en),
      expression: "form.description_en"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "form_description_en",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.description_en)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description_en", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "name": "form_category"
    }
  }, [_vm._v("Category")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.category),
      expression: "form.category"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "form_category",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "category", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "name": "form_form_type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.form_type),
      expression: "form.form_type"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "form_form_type"
    },
    domProps: {
      "value": (_vm.form.form_type)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "form_type", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "name": "form_design_path"
    }
  }, [_vm._v("Design Path")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.design_path),
      expression: "form.design_path"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "form_design_path"
    },
    domProps: {
      "value": (_vm.form.design_path)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "design_path", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "name": "form_image_url"
    }
  }, [_vm._v("Image")]), _vm._v(" "), (!_vm.image) ? _c('div', [_vm._v("\n            Select an image\n                    "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]) : _c('div', [_c('img', {
    attrs: {
      "src": _vm.image
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.removeImage
    }
  }, [_vm._v("Remove image")])])]), _vm._v(" "), _vm._m(0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Create")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-352ce895"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/form/create-form.vue
// module id = 368
// module chunks = 1